import { Outlet, useRouteError } from "react-router-dom";

export function DiabolocomInjectionPage() {
    return (
        <div className="flash-injection">
            <Outlet />
        </div>
    );
}

export function ErrorBoundary() {
    const error = useRouteError() as Error;
    return (
        <div className="error">
            <h2>Une erreur est survenue</h2>
            <p>{error.message}</p>
        </div>
    );
}
